import type { ObjectValues } from "@/src/shared/types/objectValues";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

export const DS_PAGE_CONTENT_PADDING = {
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
} as const;

export interface DSPageContentProps {
  padding?: ObjectValues<typeof DS_PAGE_CONTENT_PADDING>;
}

export interface DSPageColumnsProps {
  minColumnWidth?: number;
  modelValue: number[];
  resizeHandleAriaLabel: string;
}
